import React from 'react'

import { Col } from 'antd'
import FilterDiv from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import { FilterText, FullWidthRow } from '../../style'

const TableFilter = ({
  BreadShowStudent,
  setFolderSearch,
  totalCount,
  currentCount,
  searchBy,
  FilterMenu,
  isMenuOpen,
  setIsMenuOpen,
  onOpenChange,
  filterdata,
  handleSearch,
  handleFolderSearch,
  folderSearch,
  placeholder = 'Search by name',
}) => {
  return (
    <TableTop
      centerVertically
      style={{ paddingTop: '0px', paddingRight: '0px' }}
      radius={
        BreadShowStudent !== 'true' || filterdata.length !== 0
          ? '10px'
          : '10px 10px 0px 0px'
      }
      background="#fff"
      borderbottom={BreadShowStudent && filterdata.length === 0}
    >
      <FullWidthRow>
        <Col flex={BreadShowStudent !== 'true' ? 24 : 3.5}>
          <SearchInput
            width={'100%'}
            placeholder={placeholder}
            bordered={false}
            height={'50px'}
            searchValue={BreadShowStudent === 'true' ? searchBy : folderSearch}
            handleSearch={
              BreadShowStudent === 'true' ? handleSearch : handleFolderSearch
            }
          />
        </Col>
        {BreadShowStudent === 'true' && (
          <Col flex={16}>
            <FilterDiv
              width={'100%'}
              overlayMenu={FilterMenu}
              open={isMenuOpen}
              setOpen={setIsMenuOpen}
              onOpenChange={onOpenChange}
            />
          </Col>
        )}
        {BreadShowStudent === 'true' && (
          <Col flex={4.5}>
            <FilterText>
              Showing {currentCount} of {totalCount}
            </FilterText>
          </Col>
        )}
      </FullWidthRow>
    </TableTop>
  )
}

export default TableFilter
